// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mr-10[data-v-4c4fb4c6] {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
